import { useQuery } from "@tanstack/react-query";
import api from "apis";
import { GetDocumentStatusCountParams } from "apis/data-contracts";

const useDocumentStatusCountQuery = (query: GetDocumentStatusCountParams) => {
  return useQuery({
    queryKey: api.dashboard.getDocumentStatusCountKey(query),
    queryFn: () => api.dashboard.getDocumentStatusCount(query),
    select: (res) => res.data.result,
  });
};

export default useDocumentStatusCountQuery;
